// import { carbonFeeAndDividend } from "./carbonFeeAndDividend";
// import { permanentDst } from "./permanentDst";
import { flAllowRcv } from "./flAllowRcv";
// import { caCondorcetPrimaries } from "./caCondorcetPrimaries";

export const allPetitions = [
  // FL state petitions
  flAllowRcv,

  // national
  // NOTE: On 6/17/26, we are removing national petitions. they have outdated voter guide data, and i wanted to clean up the petition list for our Florida MVP.
  // carbonFeeAndDividend,
  // permanentDst,

  // CA state petitions
  // NOTE: On 4/4/25, we are removing caCondorcetPrimaries as a state petition.
  // This is because:
  // 1) Temporarily, it seems we do not have access to California Voter info to verify voters.
  // 2) We would have to do work to properly display the voter guide of this petition.
  // Given that it involves work to make work, and we cannot verify CA voters now anyways, we will just avoid this work, comment it out, and focus on Florida participation or poissibly unverified accounts.
  // IF I INTRODUCE THIS PETITION AGAIN, I WILL NEED TO MAKE SURE THE RESULTS TABLE DISPLAYS CORRECTLY FOR THE STATE LEVEL PETITION PAGE.
  // caCondorcetPrimaries,
];
